/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TargetButton = styled(Button)({
  padding: 0,
  minWidth: `${gridSize() * 5}px`,
  justifyContent: 'center',
  height: `${gridSize() * 4}px`,
});

export const TargetButtonText = styled.span({
  color: token('color.text.subtlest'),
});

export const DownIconWrapper = styled.div({
  marginLeft: `-${gridSize() * 1.5}px`,
  marginRight: `-${gridSize() * 0.75}px`,
});
